/*
 * Created by: cparaschiv
 * Date: 16.05.2013, 11:44
 * Shameless copy/paste from kendo's Observable
 * - added some comments for clarification and removed some code
 */

/**
 * @typedef EventArgs
 * @type {Object}
 * @property {Function} preventDefault
 * @property {Function} isDefaultPrevented
 */

(function () {
    'use strict';

    var preventDefault = function () {
        this._defaultPrevented = true;
    };

    var isDefaultPrevented = function () {
        return this._defaultPrevented === true;
    };

    var eventIsSuspended = function (eventName) {
        if (this._allEventsSuspended === true)
            return true;
        return this._suspendedEvents.indexOf(eventName) > -1;
    };

    var Observable = new Class({

        events: [
        /**
         * Fires when a property value is about to be changed.
         * @event TS.Observable#propertyChanging
         * @param {EventArgs} e
         * @param {String} e.propertyName The name of the affected property
         * @param {TS.Observable} e.sender The source of the event
         */
            'propertyChanging',

        /**
         * Fires when a property value changes.
         * @event TS.Observable#propertyChanged
         * @param {EventArgs} e
         * @param {String} e.propertyName The name of the affected property
         * @param {TS.Observable} e.sender The source of the event
         */
            'propertyChanged',
        /**
         * Fires when a observable is disposed.
         * @event TS.Observable#disposed
         */
            'disposed'
        ],

        /**
         *
         */
        observables: {},

        initialize: function () {
            this._events = {};
            this._suspendedEvents = [];
            this._subscriptions = [];
            this._accessors = [];

            //create observables with default values
            for (var key in this.observables) {
                ko.createProperty(this, key, this[key] || this.observables[key]);
            }
        },

        onPropertyChanging: function (propertyName) {
            this.fireEvent('propertyChanging', {sender: this, propertyName: propertyName});
        },

        onPropertyChanged: function (propertyName) {
            this.fireEvent('propertyChanged', {sender: this, propertyName: propertyName});
        },

        on: function (eventName, handlers, scope) {
            var me = this,
                i, key,
                eventNames = typeof eventName === 'string' ? [eventName] : eventName,
                length,
                handler,
                handlersIsFunction = typeof handlers === 'function',
                evtHandlers;

            //CP: if eventName is an object config { 'eventName' : handler }
            if (handlers === undefined) {
                for (key in eventName) {
                    me.on(key, eventName[key], scope);
                }
                return me;
            }

            //CP: if eventName is an array of event names
            // and handlers is an array of functions
            for (i = 0, length = eventNames.length; i < length; i++) {
                eventName = eventNames[i];

                handler = handlersIsFunction ? handlers : handlers[eventName];

                if (handler) {
                    evtHandlers = me._events[eventName] = me._events[eventName] || [];
                    evtHandlers.push({
                        handler: handler,
                        __scope: scope
                    });
                }
            }

            return me;
        },

        fireEvent: function (eventName, e, scope) {
            var me = this,
                evtHandlers = me._events[eventName],
                fn,
                ctx,
                i,
                length;

            // make sure that all event args have default properties
            // such as sender, preventDefault, etc.
            e = (e || {});
            $.extend(e, {
                // don't add 'sender' to event arguments (causes stack overflow in knockout)
                //sender: me,
                _defaultPrevented: false,
                preventDefault: preventDefault,
                isDefaultPrevented: isDefaultPrevented
            });

            if (eventIsSuspended.call(me, eventName))
                return true;

            if (evtHandlers) {
                //CP: this copies the array, leaving the original reference untouched
                evtHandlers = evtHandlers.slice();

                for (i = 0, length = evtHandlers.length; i < length; i++) {
                    fn = evtHandlers[i].handler;
                    ctx = evtHandlers[i].__scope || scope || me;
                    fn.call(ctx, e);
                }

                return (e._defaultPrevented === true);
            }

            return false;
        },

        promiseEvent: function (eventName, e) {
            var me = this,
                evtHandlers = me._events[eventName],
                fn,
                ctx;

            if (eventIsSuspended.call(me, eventName))
                return false;

            if (evtHandlers && evtHandlers.length > 0) {
                fn = evtHandlers[0].handler;
                ctx = evtHandlers[0].__scope || me;
                return fn.call(ctx, e);
            }

            return false;
        },

        un: function (eventName, handler) {
            var me = this,
                events = me._events[eventName],
                i,
                length;

            if (eventName === undefined) {
                me._events = {};
            } else if (events) {
                if (handler) {
                    for (i = 0, length = events.length; i < length; i++) {
                        if (typeof events[i] !== 'undefined') {
                            if (events[i].handler === handler) {
                                events.splice(i, 1);
                            }
                        }
                    }
                } else {
                    me._events[eventName] = [];
                }
            }

            return me;
        },

        _suspendEvent: function (eventName) {
            var me = this;

            me._suspendedEvents.push(eventName);
        },

        _resumeEvent: function (eventName) {
            var me = this,
                idx;

            idx = me._suspendedEvents.indexOf(eventName);
            if (idx > -1) {
                me._suspendedEvents.splice(idx, 1);
            }
        },

        suspendEvents: function () {
            this._allEventsSuspended = true;
        },

        resumeEvents: function () {
            this._allEventsSuspended = false;
        },

        watch: function (propertyPath, dataSource, handler) {
            var me = this,
                accessor = new TS.PropertyAccessor({
                    propertyPath: propertyPath,
                    dataSource: dataSource,
                    handler: handler
                });
            me._accessors.push(accessor);
            return accessor;
        },

        _disposeAccessors: function () {
            var me = this;
            $.each(ko.valueOf(me._accessors), function (index, accessor) {
                accessor.dispose();
            });
            me._accessors = [];
        },

        _disposeSubscriptions: function () {
            var me = this,
                subs;

            // dispose subscriptions, will be recreated in _watch* methods
            subs = ko.valueOf(me._subscriptions);
            // dispose all ko subscriptions
            $.each(subs, function (idx, s) {
                s.dispose();
            });

            subs.length = 0;
        },

        dispose: function () {
            var me = this;

            me._disposeAccessors();

            // remove all event handlers
            $.each(me._events, function (eventName, handlers) {
                handlers.length = 0;
            });
            me._disposeSubscriptions();

            me.fireEvent('disposed');
        }
    });

    Observable.prototype.bind = Observable.prototype.on;
    Observable.prototype.unbind = Observable.prototype.un;
    Observable.prototype.trigger = Observable.prototype.fireEvent;

    TS.Observable = Observable;

})();
